
import { useState, useEffect } from 'react';

import './css/Style.css';
import { Link } from 'react-router-dom';
import { SideMenu } from '../../../components/SideMenu';
import { ShowFadeInUpSection } from '../../../components/ShowFadeInUpSection';
import { Duvidas } from '../../../components/Duvidas/Duvidas';
import { NavBarSiteV1 } from '../../../components/NavBarSite/_v1/Index';
import { FooterSiteV1 } from '../../../components/FooterSite/v1';

import { GLOBAL_LINKS_BAIXAR_ANDROID, GLOBAL_LINKS_BAIXAR_APP } from '../../global/links';
import { EstablishmentCards } from '../../../components/EstablishmentCards/Index';

import svg_logo_toome from './img/logo_toome.svg';
import svg_android from '../../global/img/android.svg';
import { openDownloadApp, openSignIn } from '../../../components/NavBarSite/_v1/WelcomeLinks';
import { LINKS_CENTRAL_DE_AJUDA, LINKS_PARA_CLIENTES, LINKS_TERMOS } from '../../../Links';
import { utils_site_ref_launch_app } from '../../../components/utils/utils_site_ref';


function Sobre({ Titulo, BackPage, NavDestacada, ShowAlertView }) {

    const [state, setState] = useState(false);
    useEffect(() => {

        if (!state)
            setState(true);
        else {
            window.scrollTo({ top: 0, behavior: 'instant' });

            ShowFadeInUpSection('msg_inicial');
            ShowFadeInUpSection('problemas');
            ShowFadeInUpSection('lista-inteligente');
            ShowFadeInUpSection('lista-container');
            ShowFadeInUpSection('funcionalidades-grid');
            ShowFadeInUpSection('container-vantagens');
            ShowFadeInUpSection('funcionalidades');
            ShowFadeInUpSection('containerSection');
            ShowFadeInUpSection('titulo-diferenciais');
            ShowFadeInUpSection('diferenciais');
            ShowFadeInUpSection('secao_engajamento');
            ShowFadeInUpSection('impactos');
            ShowFadeInUpSection('titulo-impacto');
            ShowFadeInUpSection('impactos-positivos-sectio');
            ShowFadeInUpSection('baixe');
            ShowFadeInUpSection('informativo');
            ShowFadeInUpSection('duv');
            ShowFadeInUpSection('pos-vantagens');
            ShowFadeInUpSection('contato');


            const faqSection = document.getElementById('js_link_container_fac');
            const js_container_fac = document.getElementById('js_container_fac');
            const faq_topic = document.getElementsByName("faq_topic");
            if (faqSection !== null && js_container_fac !== null && faq_topic !== null) {
                js_container_fac.style.display = '';
                faqSection.addEventListener('click', function () {
                    js_container_fac.style.display = js_container_fac.style.display == '' ? 'block' : '';
                });
                faq_topic.forEach(function (topic) {
                    topic.addEventListener('click', function () {
                        const answer = this.nextElementSibling;
                        answer.style.display = (answer.style.display === 'none' || answer.style.display === '') ? 'block' : 'none';
                        if (!topic.classList.contains('faq_topic_sel'))
                            topic.classList.add('faq_topic_sel')
                        else
                            topic.classList.remove('faq_topic_sel')
                    });
                    topic.click();
                    topic.click();
                });
            }

            const furl_redirect = document.getElementById('furl_redirect');
            if (furl_redirect !== null)
                furl_redirect.value = window.location.href;
            function muralGetURLParam(param) {
                const parametros = window.location.href.substring(1).split('&');
                for (let i = 0; i < parametros.length; i++) {
                    const parametro = parametros[i].split(param + '=');
                    if (parametro.length == 2)
                        return parametro[1];
                }
                return null;
            }
            const msg_alerta = muralGetURLParam('msg_alert');
            if (msg_alerta !== null) {
                window.alert(msg_alerta.replace(/%20/g, " "));
                setTimeout(() => {
                    const gotoNextPage = window.parent.document.getElementById('gotoNextPage');
                    if (gotoNextPage !== null) {
                        gotoNextPage.style.animation = '.2s linear forwards gotoNextPageAnimeSlideClose';
                        gotoNextPage.src = '#/anim/';
                    }
                }, 30);

                setTimeout(() => {
                    window.parent.document.querySelectorAll("html")[0].style.overflow = "auto";
                    window.parent.scrollTo({ top: localStorage.getItem("LSTOR_Y_SCROLL_MURAL_TO_BACK_GROUND"), behavior: "instant" });
                }, 1);
            }

            document.getElementById('SaibaMural').addEventListener('click', function () {
                document.getElementById('popupContent').innerHTML = '<p> O <b style="color: #dc4a03;">mural das ofertas</b> é uma funcionalidade em formato de rede social. Através dela, é possivel encontrar as melhores ofertas de supermercado e compartilhar as promoções que você encontrar. Enquanto o TooMe capta parceiros para, posteriormente, oferecer <b style="color: #dc4a03;">ganhos reais</b>, você ganha pontos ao postar uma oferta.</p>';
                document.getElementById('popup').style.display = 'block';
                document.getElementById('overlay').style.display = 'block';
            });


            document.getElementById('SaibaLista').addEventListener('click', function (e) {
                document.getElementById('popupContent').innerHTML = '<p>A <b style="color: #dc4a03;">lista inteligente</b> é uma funcionalidade que permite cadastrar seus produtos digitando, lendo o código de barras ou escaneando sua nota fiscal. Receba alertas quando algum item entrar em oferta pelo monitor de preços e use os filtros para descobrir as melhores rotas de compra e os maiores descontos e economize até 75% nas suas compras!</p>';
                document.getElementById('popup').style.display = 'block';
                document.getElementById('overlay').style.display = 'block';
            });

            document.getElementById('SaibaMapa').addEventListener('click', function () {
                document.getElementById('popupContent').innerHTML = '<p>O <b style="color: #dc4a03;">mapa das ofertas</b> é uma funcionalidade inovadora que visa unificar a busca por promoções e promover uma comunicação mais efetiva. No mapa, aparecem todos os mercados cadastrados na sua região, além de mensagens personalizadas de cada estabelecimento. Ao clicar em um mercado, você será direcionado para um ambiente exclusivo com as ofertas daquele mercado, dentro do aplicativo TooMe. Além disso, em datas comemorativas, o visual do mapa será personalizado, com grandes eventos e promoções especiais.</p>';
                document.getElementById('popup').style.display = 'block';
                document.getElementById('overlay').style.display = 'block';
            });

            document.getElementById('SaibaBeneficios').addEventListener('click', function () {
                document.getElementById('popupContent').innerHTML = '<p>O <b style="color: #dc4a03;">TooMe</b> possui jogos educativos para você ganhar vantagens enquanto se diverte, além de dois programas de benefícios em fase final de desenvolvimento que, além de ajudarem você a economizar, ainda proporcionam vantagens exclusivas.</p>';
                document.getElementById('popup').style.display = 'block';
                document.getElementById('overlay').style.display = 'block';
            });

            document.getElementById('SaibaBusca').addEventListener('click', function () {
                document.getElementById('popupContent').innerHTML = '<p>O <b style="color: #dc4a03;">buscador de preços</b> é uma funcionalidade padrão do TooMe! Com ele, você poderá pesquisar de forma personalizada o preço de produtos de supermercado, digitando o nome do produto ou escaneando o código de barras com a câmera do seu celular. Dessa forma, é possível economizar tempo e dinheiro e tomar decisões mais rápidas nas suas compras.</p>';
                document.getElementById('popup').style.display = 'block';
                document.getElementById('overlay').style.display = 'block';
            });

            document.getElementById('SaibaEncarte').addEventListener('click', function () {
                document.getElementById('popupContent').innerHTML = '<p>O <b style="color: #dc4a03;">encarte e notificação por localização</b> é uma funcionalidade para receber notificações de promoções quando você estiver próximo ao mercado e visualizar o encarte de acordo com sua localização atual, tornando a descoberta de uma oferta conveniente por estar passando próximo a um supermercado.</p>';
                document.getElementById('popup').style.display = 'block';
                document.getElementById('overlay').style.display = 'block';
            });

            document.getElementById('SaibaCuponsEventos').addEventListener('click', function () {
                document.getElementById('popupContent').innerHTML = '<p><b style="color: #dc4a03;">EM BREVE</b>, o TooMe terá uma seção com vários descontos em estabelecimentos, para ajudar você a economizar ainda mais. Logo mais, também aparecerão estabelecimentos locais com ofertas exclusivas, além das melhores campanhas dos mercados da sua região.</p>';
                document.getElementById('popup').style.display = 'block';
                document.getElementById('overlay').style.display = 'block';
            });

            document.getElementById('closeBtn').addEventListener('click', function () {
                document.getElementById('popup').style.display = 'none';
                document.getElementById('overlay').style.display = 'none';
            });

            document.getElementById('overlay').addEventListener('click', function () {
                document.getElementById('popup').style.display = 'none';
                document.getElementById('overlay').style.display = 'none';
            });
        }
    }, [state]);

    function toggleContent(id) {
        var content = document.getElementById(id + 'Content');
        if (content.style.display === "none") {
            content.style.display = "block";
        } else {
            content.style.display = "none";
        }
    }

    return (
        <div className="geral">
            <>
                <NavBarSiteV1 />
                <section className='banner-sobre'>

                    <section className="banner-inicial">
                        <div className="banner-inicial-container">
                            <img
                                src={svg_logo_toome}
                                alt="Banner inicial"
                                loading='lazy'
                                width={753}
                                height={274}
                            />
                        </div>
                    </section>

                    <section className="msg_inicial">
                        <h2>
                            Monitore preços, compartilhe ofertas de supermercado e economize tempo e dinheiro!
                        </h2>
                    </section>
                </section>
                <main className='main_geral_sobre'>

                    <div className="overlay" id="overlay"></div>
                    <div className="popup" id="popup">
                        <button className="icone_close" id="closeBtn">&times;</button>
                        <div id="popupContent"></div>
                    </div>

                    <hr className="hr" />
                    <section className="problemas">
                        <h1>Quanto mais usuários, mais inteligente e completo o <b>TooMe</b> fica!</h1>
                        {/* <p>Este é um aplicativo colaborativo, com um mural de ofertas que gera rendimento quando você posta uma promoção 🤑. Com isso, outros usuários descobrem produtos que poderiam passar despercebidos, e os mercados ganham uma posição de destaque.</p> */}
                        <p>Enquanto os usuários descobrem ofertas que poderiam passar despercebidas, os mercados permanecem no radar dos clientes e conquistam uma posição de destaque.</p>
                    </section>

                    <section id="lista-inteligente">
                        <div className="lista-container">
                            <div className="lista-texto">
                                <h2>🧠 Antes de sair de casa, deixe a IA do TooMe montar sua rota de economia!</h2>
                                <p>
                                    Selecione os produtos que você quer comprar e o TooMe mostra
                                    automaticamente:
                                </p>

                                <div className="beneficios-cards">
                                    <div className="beneficio-card">
                                        <span className="emoji">🛒</span>
                                        <p>
                                            Onde estão os <strong>MAIORES descontos</strong>
                                        </p>
                                    </div>

                                    <div className="beneficio-card">
                                        <span className="emoji">🚗</span>
                                        <p>
                                            As <strong>MELHORES rotas</strong> para economizar tempo, dinheiro e combustível
                                        </p>
                                    </div>

                                    <div className="beneficio-card">
                                        <span className="emoji">📍</span>
                                        <p>
                                            Os mercados com <strong>MAIS produtos da sua lista</strong>
                                        </p>
                                    </div>

                                    <div className="beneficio-card">
                                        <span className="emoji">🤖</span>
                                        <p>
                                            Tudo isso com o poder da <strong>IA do TooMe</strong>
                                        </p>
                                    </div>
                                </div>

                                <p className="lista-destaque">
                                    Use os filtros da Lista Inteligente e descubra o caminho mais rápido para economizar até <b>75%</b> nas compras!
                                </p>
                            </div>

                            <div className="lista-celular">
                                <img
                                    src={require("./img/listaCel2.avif")}
                                    alt="Tela do app TooMe mostrando a lista inteligente"
                                    className="imagem-celular"
                                />
                            </div>
                        </div>
                    </section>


                    <div className='funcionalidades'>
                        <h2><u>Funcionalidades</u></h2>
                        <p>Com <b>inteligência artificial</b>, o TooMe pode te ajuda a encontrar as melhores ofertas!</p>
                    </div>

                    <section className="containerSection">
                        <section className="container_vantagens">
                            <div>
                                <div>
                                    <img src={require("../../global/img/lista.png")} alt='Icone de uma lista' loading='lazy' />
                                    <p><b>Lista Inteligente</b></p>
                                </div>
                                <p className="p" id="SaibaLista">SAIBA MAIS</p>
                            </div>


                            <div>
                                <div>
                                    <img src={require("../../global/img/geo.png")} alt='Icone de um celular com um paga desenhado' loading='lazy' />
                                    <p>
                                        <b>Ofertas por proximidade</b>
                                    </p>
                                </div>

                                <p className="p" id="SaibaEncarte">SAIBA MAIS</p>
                            </div>


                            <div>
                                <div>
                                    <img src={require("./img/lupa.png")} alt='Icone de uma lupa' loading='lazy' />
                                    <p>
                                        <b>Buscador de Preços</b>
                                    </p>
                                </div>

                                <p className="p" id="SaibaBusca">SAIBA MAIS</p>
                            </div>

                            <div>
                                <div>
                                    <img src={require("../../global/img/mapa.png")} alt='Icone de um mapa' loading='lazy' />
                                    <p><b>Mapa das Ofertas</b></p>
                                </div>
                                <p className="p" id="SaibaMapa">SAIBA MAIS</p>
                            </div>

                            <div>
                                <div>
                                    <img src={require("../../global/img/encarte.png")} alt='Icone de encarte' loading='lazy' />
                                    <p><b>Mural de Ofertas</b></p>
                                </div>
                                <p className='orange' id="SaibaMural">SAIBA MAIS</p>
                            </div>

                            <div>
                                <div>
                                    <img src={require("./img/2.png")} alt='Imagem do Orácio, mascote do TooMe' loading='lazy' />
                                    <p className="p_vantagens">
                                        <b>Jogos e Benefícios</b>
                                    </p>
                                </div>

                                <p className="p" id="SaibaBeneficios">SAIBA MAIS</p>
                            </div>

                            <div>
                                <div>
                                    <img src={require("./img/cupons1.png")} alt='Icone de cupom de descontos' loading='lazy' />
                                    <p>
                                        <b>Cupons e Eventos</b>
                                    </p>
                                </div>

                                <p className="p" id="SaibaCuponsEventos">SAIBA MAIS</p>
                            </div>
                        </section>
                    </section>

                    <section className='container-vantagens'>
                        <div className='vantagens'>
                            <h2><u>Vantagens</u></h2>
                            <p>Não somos um simples meio de divulgação: o TooMe é um ecossistema de funcionalidades vantajosas e essenciais para o dia a dia de compras, pois é uma ferramenta que faz o que nenhuma outra plataforma proporciona.</p>
                        </div>

                        <section className="vantagens_topicoss">
                            <ul>
                                {/* <li> Remuneração das postagens.</li> */}
                                <li> Economia real de tempo e dinheiro.</li>
                                <li> Centralização de ofertas em um só lugar.</li>
                                <li> Monitor de preço na lista inteligente.</li>
                                <li> Ofertas reais, com preços atualizados diariamente.</li>
                                <li> Decisões de compra mais rápidas e inteligentes.</li>
                                <li> As melhores rotas de compra e os maiores descontos.</li>
                                <li> Recomendações baseadas em comportamento de consumo.</li>

                            </ul>
                            <img
                                src={require("./img/inicio.avif")}
                                alt='Imagem da página principal do aplicativo TooMe em um celular'
                                loading='lazy'
                                width={346}
                                height={709}
                            />
                        </section>
                    </section>

                    <section className="pos-vantagens">
                        <div>
                            <h2>Economize até <span>75%</span> nos produtos do dia a dia</h2>
                            <p>Com o TooMe, você encontra as melhores ofertas nos mercados da sua cidade. Baixe agora ou cadastre-se gratuitamente!</p>
                            <div className="cta-buttons">
                                <button className="cta-btn download" onClick={openDownloadApp}>📲 Baixar o App</button>
                                <button className="cta-btn signup" onClick={openSignIn}>📝 Cadastrar-se</button>
                            </div>
                        </div>
                    </section>

                    <div className='titulo-diferenciais'>
                        <h2><u>Sabe por que os preços no TooMe são confiáveis?</u></h2>
                    </div>

                    <section className="diferenciais">
                        <div>
                            <div>
                                <div>📄</div>
                                <h3>Notas Fiscais</h3>
                                <p>Envio de notas fiscais reais por pessoas físicas e parceiros jurídicos.</p>
                            </div>

                            <div>
                                <div>🤝</div>
                                <h3>Associados e Parceiros</h3>
                                <p>Associados e Parceiros do TooMe contribuem com dados verificados.</p>
                            </div>

                            <div>
                                <div>🤖</div>
                                <h3>Inteligência Artificial</h3>
                                <p>Uso de inteligência artificial e processamento digital de imagens.</p>
                            </div>

                            <div>
                                <div>📢</div>
                                <h3>Colaboração</h3>
                                <p>Ofertas encontradas e compartilhadas pelos consumidores.</p>
                            </div>

                        </div><br /><br />

                        <p>Não é apenas sobre ir ao mercado, é sobre ir melhor informado, gastar menos e ainda ganhar <b style={{ color: '#d65616e2' }}>pontos</b> por isso.</p>

                    </section>


                    <hr className="linha" />

                    <section className='impactos'>

                        <div className="titulo-impacto">
                            <h2><b>Impactos Positivos</b>
                            </h2>
                            <p>Atuamos nas três dimensões da sustentabilidade e contribuimos para diversos Objetivos de Desenvolvimento Sustentável (ODS) por meio das funcionalidades oferecidas no aplicativo. O TooMe foi projetado para atender a todos, principalmente as classes C, D e E, grupos que mais precisam de ferramentas de economia. Além disso, os dados gerados podem auxiliar governos e instituições na formulação de políticas públicas.
                            </p>
                        </div>

                    </section>

                    <section className="impactos-positivos-section">
                        <details className="impacto-details">
                            <summary>
                                🌍 Impacto Social e Econômico
                                <div>Benefícios que promovem a sustentabilidade</div>
                            </summary>
                            <div className="impacto-card">
                                <ul>

                                    <li><b>Desigualdade e Acesso a Bens Essenciais:</b> Com a transparência de preços proporcionada pelo TooMe, os consumidores têm acesso rápido, fácil e igualitário às melhores ofertas de produtos essenciais. Dessa forma, o aplicativo contribui para a redução dos gastos familiares, facilita o acesso a bens indispensáveis e colabora para a diminuição da desigualdade, beneficiando especialmente as pessoas em situação de vulnerabilidade financeira.</li>

                                    <li><b> Geração de Informações Essenciais:</b> Ao utilizar o TooMe, padrões de buscas e consumo são analisados, e essas são
                                        informações valiosas para formulação de políticas públicas, ajudando governos e organizações a formularem estratégias eficazes de <b>combate à
                                            pobreza e a desigualdade.</b></li>

                                    <li><b>Economia de Dinheiro:</b> Com o compartilhamento de ofertas no mural e a opção padrão de busca de preços, todos economizam, principalmente as
                                        famílias de baixa renda e os mais vulneráveis.</li>

                                    <li><b>Economia de Tempo:</b> Com o planejamento de compras baseado nos preços e promoções disponíveis, haverá
                                        uma
                                        redução no tempo gasto nas buscas, permitindo que os usuários dediquem mais tempo
                                        à sua saúde, lazer e bem-estar.</li>

                                    <li><b>Redução do Desperdício Alimentar:</b> O TooMe está desenvolvendo uma sinalização das ofertas com produtos próximos à data de
                                        validade, contribuindo para a diminuição da quantidade de alimentos descartados.</li>

                                    <li><b>Educação Financeira e Conscientização:</b> A exibição de preços de múltiplos supermercados permite escolhas de compra mais informadas e conscientes. Além disso, o TooMe conta com jogos educativos que promovem a educação financeira de forma acessível e interativa.</li>

                                    {/* <b>Parcerias com ONGs:</b> O TooMe terá parcerias para integração de doações de alimentos e
    campanhas sociais, apoiando iniciativas de combate à fome e ao desperdício alimentar.<br /><br /> */}

                                    <li><b>Apoio a Pequenos Negócios:</b> A inclusão de supermercados locais nas ofertas, que muitas vezes
                                        não têm tanto investimento em divulgação, aumentará a visibilidade e competitividade desses
                                        pequenos estabelecimentos, fazendo com que as pessoas economizem ainda mais.</li>
                                    {/* 
                        <p><b>Recompensas, eventos e sorteios:</b> Com o TooMe, todos os usuários
                            podem receber informações de descontos, obter recompensas e vantagens exclusivas para economizar dinheiro. Além
                            disso, semanalmente, todos podem conferir os melhores eventos promovidos no TooMe com sorteios e
                            muitas ofertas!</p> */}


                                    <li><b>Aproveitamento de Trajeto:</b> Com a funcionalidade exclusiva de notificações por localização, os
                                        clientes que estão passando pelo mercado vão receber as promoções e potencializar seu tempo, já que
                                        estarão próximos ao mercado.</li>
                                </ul>
                            </div>
                        </details>

                        <details>
                            <summary>
                                🌱 Impacto Ambiental
                                <div>Ações que promovem a sustentabilidade</div>
                            </summary>
                            <div className="impacto-card">
                                <ul>
                                    {/* <b>Promoção de Produtos e Marcas Sustentáveis:</b> Com o destaque de marcas e produtos orgânicos e
    sustentáveis, o TooMe incentiva as escolhas de consumo mais conscientes e ecológicas. Acesse a
    <Link to={'#'} className="a_sustentabilidade"> Seção Consciente</Link>.<br /><br /> */}

                                    <li><b>Apoio à Economia Circular:</b> Ao detectar uma possível compra no supermercado e também de forma
                                        regular, o TooMe terá notificações com informações sobre reciclagem e reaproveitamento de
                                        embalagens, promovendo práticas de economia circular entre os consumidores.</li>

                                    <li><b>Redução do Uso de Papel:</b> Com o recebimento de ofertas e encartes geolocalizados ao se aproximar de um supermercado, os folhetos físicos tornam-se cada vez mais desnecessários. Cada encarte impresso que deixa de circular representa uma redução de 15g de carbono no planeta. Simples assim.</li>

                                    <li><b>Menor Pegada de Carbono:</b> O planejamento de compras com base em ofertas e promoções de forma
                                        organizada, reduz a necessidade de múltiplas idas ao supermercado e promove a combinação de compras
                                        coletivas, diminuindo a emissão de carbono.</li>

                                    <li><b>Selo Máxima economia:</b> Nas ofertas, os produtos que estão próximos ao vencimento, posteriormente, receberão o selo "Máxima Economia". Essa identificação ajuda tanto os mercados quanto os usuários a contribuírem para a redução do desperdício e fortalece práticas que beneficiam o meio ambiente e a sociedade como um todo.</li>

                                    <li><b>Jogos Interativos:</b> O TooMe tem jogos educativos e interativos que, além de proporcionar
                                        benefícios,
                                        educam os consumidores sobre práticas de sustentabilidade.</li>

                                    <li><b>Promoções de Iniciativas Verdes:</b> Divulgaremos eventos e iniciativas ambientais locais,
                                        aumentando a participação dos consumidores em atividades sustentáveis.</li>
                                </ul>
                            </div>
                        </details>
                    </section>

                    <hr className="linha" />

                    <br />

                    <section className='baixe'>
                        <h2>Ainda não é cadastrado no TooMe?</h2>
                        <p>Então baixe o app agora e aproveite todas as vantagens!</p>

                        <div>
                            <Link
                                to={GLOBAL_LINKS_BAIXAR_APP}
                                aria-label='Página de baixar aplicativo'
                            >
                                <img
                                    src={require("./img/duplo.avif")}
                                    alt='Captura de tela do aplicativo TooMe mostrada em um celular'
                                    loading='lazy'
                                    width={519}
                                    height={427}
                                />
                            </Link>

                            <div>
                                <a
                                    href={GLOBAL_LINKS_BAIXAR_ANDROID}
                                    aria-label='Redirecionamento para página da Google Play para baixar o TooMe'
                                    target='black'
                                ><img className='android' alt='Icone da Google Play para baixar o aplicativo' src={svg_android} loading='lazy' /></a>

                                <p>Em breve para iOS. Enquanto isso, acesse a <b style={{ cursor: 'pointer', color: 'gold', textDecoration: 'underline', margin: '0px 10px' }} onClick={utils_site_ref_launch_app}>versão web</b> do app diretamente pelo seu celular.</p>

                            </div>
                        </div>

                    </section>

                    <EstablishmentCards />

                    <div className="ajuste-margin"></div>

                    <Duvidas />

                    <div className='faq_section' id="js_container_fac">
                        <section className='espaco'>
                            <div className='faq_topic' name="faq_topic">
                                <li><b>O que é o TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>O TooMe é um aplicativo que permite aos usuários buscar e compartilhar ofertas e promoções de supermercados, ganhando benefícios e com várias funcionalidades relevantes para o dia a dia de compras, ajudando-os a economizar tempo e dinheiro em suas compras diárias. <a target='blank' href={GLOBAL_LINKS_BAIXAR_APP} style={{ color: '#d65616e2' }} >Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>O TooMe é gratuito?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Sim, o TooMe é um aplicativo gratuito para download e uso. <a target='blank' href={GLOBAL_LINKS_BAIXAR_APP} style={{ color: '#d65616e2' }} >Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como funcionam os jogos e desafios no TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Com os jogos e desafios no TooMe, você ganha pontos que podem ser trocados por benefícios e, posteriormente, recompensas exclusivas. Além disso, você aprende práticas ambientais e de economia. <a target='blank' href={GLOBAL_LINKS_BAIXAR_APP} style={{ color: '#d65616e2' }} >Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Para que servem os pontos no TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Enquanto o TooMe capta parceiros para, posteriormente, oferecer ganhos reais aos clientes, atualmente, e de forma temporária, utilizamos pontos como recompensas. Esses pontos podem ser ganhos ao participar de jogos, programas de benefícios e desafios no TooMe, e utilizados para participar de sorteios(quando disponível), realizar buscas avançadas de preços e, futuramente, obter recompensas e produtos exclusivos dentro do aplicativo. <a target='blank' href={GLOBAL_LINKS_BAIXAR_APP} style={{ color: '#d65616e2' }} >Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como posso compartilhar ofertas no TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Você pode compartilhar ofertas no TooMe tirando uma foto e digitando os detalhes da oferta, que será então disponibilizada para outros usuários do aplicativo. <a target='blank' href={GLOBAL_LINKS_BAIXAR_APP} style={{ color: '#d65616e2' }} >Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Eu ganho algo ao compartilhar ofertas no TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Enquanto o TooMe capta parceiros para, posteriormente, oferecer ganhos reais aos clientes, atualmente, você ganhar pontos postando uma oferta. <a target='blank' href={GLOBAL_LINKS_BAIXAR_APP} style={{ color: '#d65616e2' }} >Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>O TooMe é seguro?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Sim, o TooMe prioriza a segurança dos dados dos usuários e implementa várias medidas de proteção para garantir a privacidade e segurança das informações, conforme nossos <Link style={{ color: '#d65616e2' }} to={LINKS_TERMOS}>Termos de Uso e Políticas de privacidades</Link>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como posso encontrar as melhores ofertas perto de mim?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>O TooMe utiliza as notificações do seu dispositivo para mostrar ofertas e promoções em supermercados próximos a você. Além disso, você pode personalizar a localidade que deseja ver, mudando a cidade na página inicial do aplicativo. Também é possível buscar produtos diretamente na barra de pesquisa, escrevendo o nome ou lendo o código de barras, e ativar as notificações clicando na opção "Perfil", no canto inferior direito da página principal do aplicativo. <a target='blank' href={GLOBAL_LINKS_BAIXAR_APP} style={{ color: '#d65616e2' }} >Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>O TooMe funciona em todas as cidades?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>O TooMe já tem capacidade para funcionar em todo o Paraná e em alguns outros estados do país. No entanto, para testar o desempenho inicial, o lançamento está previsto apenas para a cidade de Toledo, no Paraná. Mas fique atento: o TooMe está continuamente trabalhando para expandir sua cobertura e incluir ofertas e promoções de supermercados em diversas cidades. Verifique a disponibilidade na sua região acessando a página principal do aplicativo. <a target='blank' href={GLOBAL_LINKS_BAIXAR_APP} style={{ color: '#d65616e2' }} >Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Posso usar o TooMe para fazer compras online?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Atualmente, o TooMe é focado em buscas de ofertas e promoções em supermercados, mas futuras atualizações podem incluir funcionalidades para compras online.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como posso resgatar meus pontos?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Enquanto o TooMe capta parceiros para, posteriormente, oferecer ganhos reais aos clientes, atualmente, os pontos podem ser convertidos em consultas de preço e sorteios(quando disponível) e, posteriormente, em produtos exclusivos ou descontos que vão estar listados no aplicativo. Basta acessar a seção dos seus pontos. <a target='blank' href={GLOBAL_LINKS_BAIXAR_APP} style={{ color: '#d65616e2' }} >Baixe o aplicativo</a>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>O que acontece se eu encontrar uma oferta incorreta no TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Você pode alertar o usuário sobre o imprevisto ou, em casos mais graves de postagens indevidas, denunciar ofertas incorretas diretamente na postagem. Nossa equipe irá revisar e remover a postagem caso necessário. <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>Entre em contato</Link>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Posso sugerir novos recursos para o TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Sim, estamos sempre abertos a sugestões e feedback dos nossos usuários. Você pode enviar suas ideias através da opção <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>central de ajuda</Link>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>O TooMe coleta meus dados pessoais?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>O TooMe coleta apenas os dados necessários para fornecer um serviço eficaz e seguro, para que você obtenha todas as ofertas e promoções da sua localidade e tenha a melhor experiência possível no aplicativo. Todos os dados são tratados de acordo com os nossos <Link style={{ color: '#d65616e2' }} to={LINKS_TERMOS}>Termos de Uso e Políticas de privacidades</Link>.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como o TooMe aborda a sustentabilidade?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>O TooMe atua nas três dimensões da sustentabilidade e contribui para diversos Objetivos de Desenvolvimento Sustentável (ODS) por meio das funcionalidades oferecidas no aplicativo. Você pode conferir, detalhadamente, acessando os <Link style={{ color: 'green' }} to={`..${LINKS_PARA_CLIENTES}`} > IMPACTOS POSITIVOS</Link> desta página.</p>
                            </div>

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como o TooMe se diferencia de outros aplicativos de compras?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>O TooMe se destaca pela combinação única de compartilhamento colaborativo com foco na experiência do usuário e várias funcionalidades exclusivas, como: Mural de fertas, mapa das ofertas, Lista inteligente, encartes e ofertas por proximidade, e muitos outros, proporcionando uma abordagem inovadora para compras.<a target='blank' href={GLOBAL_LINKS_BAIXAR_APP} style={{ color: '#d65616e2' }} > Baixe o aplicativo</a> e conheça todas as funcionalidades do TooMe!</p>
                            </div>

                            {/* 
                                <br />
                                <div className='faq_topic' name="faq_topic">
                                    <li><b>Se eu me cadastrar no programa "Acionistas TooMe!" eu vou ser sócio ou ter ações do TooMe?</b></li>
                                </div>
                                <div className='faq_answer text_faq' name="faq_answer">
                                    <p>Não, o programa "Acionistas TooMe!" como o próprio nome diz, é um programa de benefícios para os usuários que permanecerem por um tempo mínimo na plataforma e realizarem algumas atividades sugeridas. O programa é um incentivo e, ao ser validado, os usuários ganham uma porcentagem do valor destinado ao programa. Consulte as regras do programa e saiba mais.</p>
                                </div> 
                            */}

                            <div className='faq_topic' name="faq_topic">
                                <li><b>Como posso entrar em contato com o suporte do TooMe?</b></li>
                            </div>
                            <div className='faq_answer text_faq' name="faq_answer">
                                <p>Você pode entrar em contato com o suporte do TooMe diretamente através do aplicativo ou enviando um e-mail para nossa equipe de atendimento ao cliente. Acessar a <Link style={{ color: '#d65616e2' }} to={LINKS_CENTRAL_DE_AJUDA}>central de ajuda</Link>.</p>
                            </div>

                        </section>
                    </div>

                </main >
                <FooterSiteV1 />
                <SideMenu></SideMenu>
            </>
        </div >
    );
}

export default Sobre;